import { useTranslation } from 'react-i18next';
import { Rocket, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PremiumComingSoonBlockProps {
  onSuggestClick: () => void;
}

export const PremiumComingSoonBlock = ({ onSuggestClick }: PremiumComingSoonBlockProps) => {
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden rounded-lg border border-primary/20 bg-gradient-to-br from-primary/5 via-background to-primary/10 p-6 shadow-lg">
      {/* Animated background elements */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent animate-shimmer opacity-40" />
      
      {/* Content */}
      <div className="relative z-10 space-y-4">
        {/* Header with animated rocket */}
        <div className="flex items-start gap-3">
          <div className="relative">
            <Rocket className="h-8 w-8 text-primary animate-bounce" />
            <div className="absolute inset-0 blur-xl bg-primary/30 animate-pulse -z-10" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
              {t('preferences.premium.comingSoon.title')}
              <Sparkles className="h-4 w-4 text-primary animate-pulse" />
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              {t('preferences.premium.comingSoon.description')}
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="space-y-2">
          <Button
            onClick={onSuggestClick}
            variant="outline"
            className="w-full border-primary/30 hover:border-primary/50 hover:bg-primary/10 transition-all duration-300"
          >
            {t('preferences.premium.comingSoon.cta')}
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            {t('preferences.premium.comingSoon.hint')}
          </p>
        </div>
      </div>

      {/* Decorative gradient corner */}
      <div className="absolute -top-12 -right-12 w-32 h-32 bg-primary/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-primary/20 rounded-full blur-3xl" />
    </div>
  );
};
